import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiBlob } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const downloadAPI = createApi({
    reducerPath: 'downloadAPI',
    baseQuery: axiosBaseQuery(restApiBlob),
    endpoints: (builder) => ({
        // Position-related downloads
        exportPositions: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.EXPORT_POSITION_DATA,
                method: 'POST',
            }),
        }),
        exportPositionsWithCompaFields: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.EXPORT_POSITION_DATA_WITH_COMPA_FIELDS,
                method: 'POST',
            }),
        }),
        downloadPositionTemplate: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.DOWNLOAD_POSITION_DATA_TEMPLATE,
                method: 'POST',
            }),
        }),
        downloadPositionTemplateWithCompaFields: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.DOWNLOAD_POSITION_DATA_TEMPLATE_WITH_COMPA_FIELDS,
                method: 'POST',
            }),
        }),
        downloadPositionExternalIdTemplate: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.DOWNLOAD_POSITION_EXTERNAL_ID_TEMPLATE,
                method: 'POST',
            }),
        }),
        // Change Request downloads
        downloadAttachmentsForChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DOWNLOAD_ATTACHMENTS_FOR_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        // Master Attributes downloads
        exportAuditLogs: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.EXPORT_AUDIT_LOGS,
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useExportPositionsMutation,
    useExportPositionsWithCompaFieldsMutation,
    useDownloadPositionTemplateMutation,
    useDownloadPositionTemplateWithCompaFieldsMutation,
    useDownloadPositionExternalIdTemplateMutation,
    useDownloadAttachmentsForChangeRequestMutation,
    useExportAuditLogsMutation,
} = downloadAPI;
